<div fxLayout="column" fxLayoutAlign="center center" class="main-container">
    <h1>Enrichment rules in "{{ruleset.DisplayName ? ruleset.DisplayName : 'Unknown'}}" ruleset</h1>
    <h2>Rules</h2>
    <div *ngIf="ruleset.Rules.length === 0">
        No rules define yet.
    </div>
    <div *ngIf="ruleset.Rules.length > 0">
        <table mat-table [dataSource]="ruleset.Rules">
            <ng-container matColumnDef="ruleDesc">
                <th mat-header-cell *matHeaderCellDef>Rule</th>
                <td mat-cell *matCellDef="let rule">{{printRule(rule)}}</td>
            </ng-container>
            <ng-container matColumnDef="ruleActionList">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let rule">
                    <ul *ngFor="let action of rule.Actions">
                        <li>{{printAction(action)}}</li>
                    </ul>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let rule; let i = index;">
                    <button mat-icon-button color="primary" [routerLink]="['./edit', i]" [state]="{'ruleset': ruleset}">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="onClickDelete(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="rulesColumnsDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: rulesColumnsDisplay;"></tr>
        </table>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <button mat-raised-button color="primary" [class.spinner]="isSaving" (click)="onClickSave()"
            [disabled]="isSaving">{{isSaving ? 'Saving...' : 'Save'}}</button>&nbsp;
        <button mat-raised-button color="accent" (click)="onClickCancel()" [disabled]="isSaving">Cancel</button>
    </div>
    <button mat-fab color="primary" aria-label="Add new rule" class="main-fab--absolute" [routerLink]="['./add']"
        [state]="{'ruleset': ruleset}">
        <mat-icon>add</mat-icon>
    </button>
</div>